'use client';
export type {BoxProps};
import {Box, BoxProps} from '@mui/material';

const MuiBox = Box;
export default MuiBox;
